const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function emailDocId(email: string): string {
  const id = email.trim().toLowerCase();
  if (!EMAIL_RE.test(id) || id.includes('/')) {
    throw new Error('Invalid email');
  }
  return id;
}

export function photoIdFromFilename(filename: string): string {
  const base = filename.trim().split(/[/\\]/).pop() ?? filename;
  const id = base.replace(/\.[^.]+$/, '').toLowerCase();
  if (!/^dsc_\d{4}$/.test(id)) {
    throw new Error(`Unexpected photo filename: ${filename}`);
  }
  return id;
}

export function pageCount(total: number, pageSize: number): number {
  if (pageSize <= 0) throw new Error('pageSize must be positive');
  return Math.max(1, Math.ceil(Math.max(0, total) / pageSize));
}

export function clampPage(page: number, total: number, pageSize: number): number {
  const max = pageCount(total, pageSize);
  if (!Number.isFinite(page)) return 1;
  return Math.min(max, Math.max(1, Math.floor(page)));
}

export const PAGE_SIZE = 24;
export const ALBUM_ID = 'shashtipoorthi-2026';
